import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
//import images
import logolight from "../../assets/images/khozi.png";
import logoDark from "../../assets/images/khozi.png";

const EmailVerification1 = () => {
  document.title =
    "Verificação de Email | Khozi";
  return (
    <React.Fragment>
      <div className="authentication-bg min-vh-100">
        <div className="bg-overlay bg-white"></div>
        <Container>
          <div className="d-flex flex-column min-vh-100 px-3 pt-4">
            <Row className="justify-content-center my-auto">
              <Col md={8} lg={6} xl={4}>
                <div className="text-center py-5">
                  <div className="mb-4 mb-md-5">
                    <Link to="/control-panel" className="d-block auth-logo">
                      <img
                        src={logoDark}
                        alt=""
                        height="120"
                        className="auth-logo-dark"
                      />
                      <img
                        src={logolight}
                        alt=""
                        height="120"
                        className="auth-logo-light"
                      />
                    </Link>
                  </div>
                  <div className="mb-4 mb-md-5">
                    <div className="avatar-lg mx-auto">
                      <div className="avatar-title bg-light text-primary display-5 rounded-circle">
                        <i className="uil uil-envelope-alt"></i>
                      </div>
                    </div>
                  </div>
                  <div className="text-muted">
                    <h4 className="">Verifique o seu email</h4>
                    <p>
                      Enviámos-lhe um email de verificação{" "},
                      Por favor, confira a sua caixa de entrada e clique no link de verificação para ativar a sua conta.
                    </p>
                    <p>
                      Se não recebeu o email, verifique a sua pasta de spam.
                    </p>                    
                  </div>
                </div>
              </Col>
            </Row>

            <Row>
              <Col lg={12}>
                <div className="text-center text-muted p-4">
                  <p className="mb-0">
                    &copy; {new Date().getFullYear()} Khozi. Desenvolvido por{" "}
                    <a
                      href="http://casco.co.mz/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      CASCO
                    </a>
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EmailVerification1;
